export default __webpack_public_path__ + "static/media/product14.9a41354e.png";